import Q from 'q';
import axios from 'axios';
axios.defaults.withCredentials = false
export default (url, method = 'get', data, headers, withCredentials = false) => {
    return axios({
        method: method,
        headers: headers,
        url: url,
        data: data,
        timeout: 30000,
        withCredentials: withCredentials
    })
};



// WEBPACK FOOTER //
// ./src/api/index.js